import React from 'react';
import { classNames } from '../../../../Services/helpers';

const DateSquare = ({date, today, onClick, ring}) => {
    return <div className={classNames(
            'h-10 w-10 rounded-lg flex justify-center items-center text-center font-bold font-dosis uppercase tracking-widest leading-4 tabular-nums',
            date === today && 'bg-brand text-white',
            date > today && 'bg-slate-100 border border-slate-200 text-brand',
            date < today && 'bg-gray-100 border border-gray-200 text-muted',
            onClick && 'cursor-pointer',
            ring && 'ring-2 ring-offset-2 ring-brand-secondary'
        )}
        onClick={() => onClick && onClick()}
    >
        {new Date(date).toLocaleDateString('en-GB', {weekday: 'short'}).substr(0, 2)}<br />
        {date.substr(8, 2)}
    </div>
}

export default DateSquare;